// import React from 'react';
// import { Route, Navigate } from 'react-router-dom';
// import { SCENARIO_PATH } from '../../Constants/Path';
// import AuthService from '../../Pages/Login/AuthService';

// const PublicRoute = ({ component: Component, restricted = false, ...rest }) => {
//     return (
//         <Route {...rest} render={props => (
//             (AuthService.getUserInfo() != null && restricted) ?
//                 <Navigate to={SCENARIO_PATH} />
//                 : <Component {...props} />
//         )} />
//     );
// };

// export default PublicRoute;

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthService from '../../Pages/Login/AuthService';
import { SCENARIO_PATH } from '../../Constants/Path';

const PublicRoute = ({ restricted = false }) => {
  const isLoggedIn = AuthService.getUserInfo() != null;

  if (isLoggedIn && restricted) {
    return <Navigate to={SCENARIO_PATH} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;